import { styled } from "../../theme/theme";

export const StyledPriceSection = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  margin: "42px 0",
});

export const StyledPriceSectionText = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: "800px",
  textAlign: "center",
  gap: "24px",
  padding: "0 24px",
});

export const StyledPriceSectionCalculatorContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  margin: "42px 0",
});
